// extracted by mini-css-extract-plugin
export default {"hideTooltip":"d--z","fadeIn":"e--z","delay":"f--z","recommendedSizeTooltip":"g--z"};